import PropTypes from 'prop-types';
import styles from './socialIcons.module.scss';
import { baseUrls, followPaths, sharePaths } from './constants';

export default function SocialIcons({
  title = 'Follow Us',
  type = 'follow',
  articleUrl = '',
}) {
  return (
    <div className={styles.socialIcons}>
      {title && <span className={styles.title}>{title}</span>}
      {Object.entries(baseUrls)?.map(([key, value], index) => {
        let link;
        switch (type) {
          case 'follow':
            link = followPaths[key] ? value + followPaths[key] : null;
            break;
          case 'share':
            link = sharePaths[key]
              ? value + sharePaths[key] + articleUrl
              : null;
            break;
          default:
            link = null;
        }

        return link ? (
          <a
            key={key}
            href={link}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={key}
          >
            <i
              className={`${styles.icon} ${styles[key]} ${
                title === '' && index === 0 ? styles.noMarginLeft : ''
              }`}
            />
          </a>
        ) : null;
      })}
    </div>
  );
}

SocialIcons.propTypes = {
  title: PropTypes.string,
  type: PropTypes.string,
  articleUrl: PropTypes.string,
};
